// CAD currency + Canadian tax helpers used across both portals.
export const HST_RATE = 0.13; // Ontario HST — estimate shown in cart

const cadFormatter = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  currencyDisplay: "symbol",
});

/** 361.88 -> "$361.88" */
export const formatCAD = (amount: number | null | undefined): string =>
  cadFormatter.format(Number.isFinite(amount as number) ? (amount as number) : 0);

/** 361.88 -> "CAD $361.88" (used for the dashboard revenue card) */
export const formatCADLong = (amount: number | null | undefined): string =>
  `CAD ${formatCAD(amount)}`;

export const estimateHST = (subtotal: number): number =>
  Math.round(subtotal * HST_RATE * 100) / 100;

export const estimateTotal = (subtotal: number): number =>
  Math.round((subtotal + estimateHST(subtotal)) * 100) / 100;
